import React from 'react';

export function FaronexoLogo({ variant = 'full', className = '', size = 40 }) {
  const isMono = variant === 'mono';
  const isIcon = variant === 'icon';
  
  const accentColor = isMono ? 'currentColor' : '#f59e0b';
  const accentOpacity = isMono ? '0.2' : '0.8';

  const IconGraphic = () => (
    <g>
      {/* Outer Shield */}
      <path 
        d="M20 36C20 36 34 29 34 16V8L20 3L6 8V16C6 29 20 36 20 36Z" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Lighthouse Base/Tower */}
      <path 
        d="M15 30L17 18H23L25 30H15Z" 
        fill="currentColor"
      />
      
      {/* Lighthouse Gallery/Top */}
      <rect x="16" y="15" width="8" height="3" fill="currentColor" rx="1" />
      <path d="M18 15V11H22V15H18Z" fill="currentColor" />
      <path d="M17 11L20 8L23 11H17Z" fill="currentColor" />

      {/* Beacon Light / Radar Waves */}
      <circle cx="20" cy="13" r="2" fill={accentColor} />
      <path 
        d="M26 9C28.5 11 28.5 15 26 17" 
        stroke={accentColor} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        fill="none"
        opacity={accentOpacity}
      />
      <path 
        d="M30 5C34 9.5 34 16.5 30 21" 
        stroke={accentColor} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        fill="none"
        opacity={accentOpacity}
      />
      <path 
        d="M14 9C11.5 11 11.5 15 14 17" 
        stroke={accentColor} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        fill="none"
        opacity={accentOpacity}
      />
      <path 
        d="M10 5C6 9.5 6 16.5 10 21" 
        stroke={accentColor} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        fill="none"
        opacity={accentOpacity}
      />
    </g>
  );

  if (isIcon) {
    return (
      <svg 
        viewBox="0 0 40 40" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        className={className} 
        width={size} 
        height={size}
        aria-label="Faronexo Logo"
      >
        <IconGraphic />
      </svg>
    );
  }

  // Full Logo (Icon + Text)
  return (
    <svg 
      viewBox="0 0 180 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className} 
      height={size}
      aria-label="Faronexo Logo"
    >
      <IconGraphic />
      <text 
        x="48" 
        y="26" 
        fontFamily="system-ui, -apple-system, sans-serif" 
        fontSize="22" 
        fontWeight="800" 
        fill="currentColor" 
        letterSpacing="0.05em"
      >
        FARONEXO
      </text>
    </svg>
  );
}

export default FaronexoLogo;